/**
 * @module HojasGasto
 */
import axios from 'api/axios'
import { useEffect, useState } from 'react'

const useFetchHojaGasto = ({ id_hoja, encr, iterator = 0 }) => {
  const [response, setResponse] = useState({})
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const fetchData = () => {
    if (loading) {
      return
    }
    setLoading(true)

    const url = `/hojasgasto/${id_hoja}` + (encr ? `?encr=${encr}` : '')

    axios
      .get(url)
      .then((request_response) => {
        const data = request_response.data
        setResponse(data)
      })
      .catch((error) => setError(error))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    fetchData()
  }, [id_hoja, iterator])

  return { response, error, loading }
}

export default useFetchHojaGasto
